import * as React from 'react'
import { createInvestorAccount } from '../../globals/ApiHooks'
import colors from '../../globals/colors'
import { showError } from '../../globals/ErrorLib'
import { TranslatedTerms } from '../../globals/TranslatedTerms'
import { createEnDaContent, lang, translateContent } from '../../globals/Translations'
import { IsMobile, useWindowSize } from '../../globals/UIHooks'
import { ContryId } from '../../shared/Globals'
import Investor from '../../shared/Investor'
import { FieldTypes } from '../../shared/KYCPolicy'
import { DynamicPropertyInput } from '../atoms/Inputs'
import Switch from '../atoms/Switch'
import { ColumnFlexBox } from '../templates/Wrappers'

type Props = {
    asyncTask: (executeable: () => Promise<Investor | undefined>) => () => Promise<void>,
    loading: boolean
}

export const CreateAccountInputs: React.FC<Props> = ({ asyncTask, loading }) => {
    const { width } = useWindowSize()

    const [country, setCountry] = React.useState<ContryId>()
    const [accountName, setAccountName] = React.useState<string>()
    const [company, setCompany] = React.useState<boolean>(false)
    const [errors, showErros] = React.useState<string>()

    const checkAccountAndCreate = async () => {
        if(!accountName || accountName.length === 0){
            showErros(translateContent(createEnDaContent("Name not filled", "Navn ikke udfyldt")))
        }
        else if (!country || country.length === 0 ){
            showErros(translateContent(createEnDaContent("Contry not filled", "Land ikke udfyldt")))
        }
        else {
            await asyncTask(async ()=> await createInvestorAccount({ accountName, country, company }))()
        }
    }

    return (
        <ColumnFlexBox>
            <p style={{color: colors.danger}}>{errors}</p>
            <div style={{ display: 'grid', gridTemplateColumns: IsMobile(width) ? "1fr" : "2fr 2fr", gridColumnGap: 20, gridRowGap: 20 }}>
                <DynamicPropertyInput setValue={(item: string) => setAccountName(item)} loading={loading}
                    fieldName={TranslatedTerms.NAME} subTitle={TranslatedTerms.PROVIDE_YOUR_ACCOUNT_NAME} type={FieldTypes.TextField} value={accountName} />
                <DynamicPropertyInput setValue={(item: ContryId) => setCountry(item)} loading={loading}
                    fieldName={TranslatedTerms.COUNTRY} type={FieldTypes.CountrySelect} value={country} />
                <button onClick={checkAccountAndCreate}>{lang(TranslatedTerms.CREATE_NEW_ACCOUNT)}</button>
                <Switch label={lang(TranslatedTerms.COMPANY_ACCOUNT)} onChange={() => setCompany(!company)} />
            </div>
        </ColumnFlexBox>
    )
}
